import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { PlatformDetectionService } from '../services/platform-detection.service';
import { IosComingSoonDialogService } from '../services/ios-coming-soon-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class IosComingSoonGuard implements CanActivate {
  constructor(
    private platformDetection: PlatformDetectionService,
    private dialogService: IosComingSoonDialogService
  ) {}

  canActivate(): boolean {
    if (this.platformDetection.isIOS()) {
      this.dialogService.open();
      return false;
    }
    return true;
  }
}
